<div class="containerpdf">
  <div class="service-doc-group service-doc-group--os" *ngIf="showOsGroup(row)">
    <span class="service-doc-group__label" aria-hidden="true">OS</span>
    <div class="service-doc-group__actions">
      <app-order-pdf-button
        [row]="row"
        [model]="model"
        (pdfStatusChanged)="pdfStatusChanged.emit()"
      ></app-order-pdf-button>

      <button
        *ngIf="isPreliminary(row)"
        type="button"
        class="service-doc-action service-doc-action--confirm"
        matTooltip="Confirmar OS"
        aria-label="Confirmar OS"
        (click)="openConfirm(row)"
      >
        <i-tabler name="circle-check" class="service-doc-action__icon"></i-tabler>
      </button>

      <button
        *ngIf="row?.order?.orderId"
        type="button"
        class="service-doc-action"
        matTooltip="Historial de recálculo"
        aria-label="Historial de recálculo"
        (click)="openHistory(row)"
      >
        <i-tabler name="history" class="service-doc-action__icon"></i-tabler>
      </button>

      <button
        *ngIf="canDeleteServiceOrder(row)"
        type="button"
        class="service-doc-action service-doc-action--danger"
        matTooltip="Eliminar Orden de Servicio"
        aria-label="Eliminar OS"
        (click)="openDialogPdfDelete(row)"
      >
        <i-tabler name="trash" class="service-doc-action__icon"></i-tabler>
      </button>
    </div>
    <button
      *ngIf="isPreliminary(row)"
      type="button"
      class="service-doc-corte"
      matTooltip="Cambiar el plazo para confirmar"
      (click)="openCorte(row)"
    >
      <i-tabler name="calendar" class="service-doc-corte__icon"></i-tabler>
      <span>
        <small>Confirmar antes del</small>
        <strong>{{ corteLabel(row) }}</strong>
      </span>
    </button>
  </div>

  <div
    class="service-doc-group service-doc-group--np"
    *ngIf="showPurchaseNotePdf && showNpGroup(row)"
  >
    <span class="service-doc-group__label" aria-hidden="true">OP</span>
    <div class="service-doc-group__actions">
      <app-purchase-note-pdf-button
        [row]="row"
        [model]="model"
        (pdfStatusChanged)="pdfStatusChanged.emit()"
      ></app-purchase-note-pdf-button>

      <button
        *ngIf="canDeletePurchaseNote(row)"
        type="button"
        class="service-doc-action service-doc-action--danger"
        matTooltip="Eliminar Orden de pedido"
        aria-label="Eliminar OP"
        (click)="openDialogDeletePurchaseNote(row)"
      >
        <i-tabler name="trash" class="service-doc-action__icon"></i-tabler>
      </button>
    </div>
  </div>

  <button
    mat-icon-button
    color="primary"
    *ngIf="canShowCreditNote(row)"
    matTooltip="Nota de crédito"
    aria-label="Nota de crédito"
    (click)="openDialogNotaCreditoProveedorComponent(row)"
  >
    <i-tabler name="receipt-tax" class="icon-18"></i-tabler>
  </button>
</div>
